
const lang ={
    Title: 'Template',
    CreateTemplate: 'Create From Template',
    New: 'New',
    SearchTemplate: 'Search template',
    SearchEmpty: 'The search content is empty',
    Cancel: 'Cancel',
    loading: 'loading...',
    error: 'Error',
    netWorkError: 'Oops， there is something wrong with your network. Please check your network',
    All: 'All',
    More: 'See more',
    Suggest: 'Suggest',
    Suggestion: 'Type the suggestion here',
    SuggestContentRequired: 'Suggest content is required',
    SuggestSubmitSuccess: 'Suggest Submit Success',
    Submit: 'Submit',
    EditNow: 'Edit Now',
    Recommended: 'Recommended template',
    MostPopular: 'Most Popular',
    AccountError: 'Please log in your account first',
    AriaSearchTemplates: 'Search templates',
    AriaCategoryFilter: 'Template categories',
    AriaCloseDialog: 'Close dialog',
    AriaSeeMore: 'See more {name} templates',
    AriaScrollLeft: 'Scroll left',
    AriaScrollRight: 'Scroll right',
    AriaLoading: 'Loading',
    AriaSlide: 'Go to slide {index}',
    AriaCarousel: 'Preview images'
};

export default lang;